import { render } from "./ReadMoreLink.vue?vue&type=template&id=7a23f5d8&scoped=true"
import script from "./ReadMoreLink.vue?vue&type=script&lang=js"
export * from "./ReadMoreLink.vue?vue&type=script&lang=js"

import "./ReadMoreLink.vue?vue&type=style&index=0&id=7a23f5d8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a23f5d8"

export default script